/** The brand for a member page whose tenant is not known yet: a slate, never Ternary's green. */
export const NEUTRAL_BRAND = "#4b5563"
